import React from 'react';
import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import Navbar from './component/Navbar';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from './pages/Home';
import Benchtrack from './pages/Benchtrack';
import About from './pages/About';
import Footer from './component/Footer';
import TechnicalConsultation from './pages/service/TechnicalConsultation';
import PlatformImplementation from './pages/service/PlatformImplementation';
import ServiceNowOptimization from './pages/service/ServiceNowOptimization';
import ManagedService from './pages/service/ManagedService';
import StrategicPlanning from './pages/service/StrategicPlanning';
import PlatformAutomation from './pages/service/PlatformAutomation';
import ItService from './pages/solutions/itWorkflows/ItService';
import ItAsset from './pages/solutions/itWorkflows/ItAsset';
import IntegratedRisk from './pages/solutions/itWorkflows/IntegratedRisk';
import ItOperations from './pages/solutions/itWorkflows/ItOperations';
import StrategicPortfolio from './pages/solutions/itWorkflows/StrategicPortfolio';
import SecurityOperations from './pages/solutions/itWorkflows/SecurityOperations';
import HrService from './pages/solutions/employeeWorkflows/HrService';
import WorkplaceService from './pages/solutions/employeeWorkflows/WorkplaceService';
import CustomerService from './pages/solutions/customerWorkflows/CustomerService';
import FieldService from './pages/solutions/customerWorkflows/FieldService';
import IntegrationHub from './pages/solutions/creatorWorkflows/IntegrationHub';
import AppEngine from './pages/solutions/creatorWorkflows/AppEngine';
import ContactUs from './pages/ContactUs';
import Registration from './pages/Registration';
import USARegistrations  from './pages/USARegister';
import CanadaRegistrations from './pages/CanadaRegister';
import SnBuddy from './pages/SnBuddy';
function App() {


  const ScrollToTop = () => {
    const { pathname } = useLocation();
    // const navigate = useNavigate()
    
    useEffect(() => {
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual'; 
      }
      window.scrollTo(0, 0); 
    }, [pathname]);
  
    return null;
  };

  return (
    <>
    <ToastContainer />
      <Router>
        <ScrollToTop/>
        <Navbar />
        <Routes>
        
          <Route path="/" element={<Home />} />
          <Route path="/products/benchtrack" element={<Benchtrack />} />
          <Route path="/products/sn-buddy" element={<SnBuddy />} />
          <Route path="/about" element={<About />} />
          <Route path='/registration' element={<Registration />} />
          <Route path="/services/technical-consultation" element={<TechnicalConsultation />} />
          <Route path="/services/platform-implementation" element={<PlatformImplementation />} />
          <Route path="/services/servicenow-optimization" element={<ServiceNowOptimization />} />
          <Route path="/services/managed-service" element={<ManagedService />} />
          <Route path="/services/strategic-planning" element={<StrategicPlanning />} />
          <Route path="/services/platform-automation" element={<PlatformAutomation />} />
          <Route path="/solutions/it-service" element={<ItService />} />
          <Route path="/solutions/it-asset" element={<ItAsset />} />
          <Route path="/solutions/it-risk" element={<IntegratedRisk />} />
          <Route path="/solutions/it-operation" element={<ItOperations />} />
          <Route path="/solutions/strategic-portfolio" element={<StrategicPortfolio />} />
          <Route path="/solutions/security-operations" element={<SecurityOperations />} />
          <Route path="/solutions/hr-service" element={<HrService />} />
          <Route path="/solutions/workplace-service" element={<WorkplaceService />} />
          <Route path="/solutions/customer-service" element={<CustomerService />} />
          <Route path="/solutions/field-service" element={<FieldService />} />
          <Route path="/solutions/app-engine" element={<AppEngine />} />
          <Route path="/solutions/integration-hub" element={<IntegrationHub />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/usa-registrations" element={<USARegistrations />} />
          <Route path="/canada-registrations" element={<CanadaRegistrations />} />
        </Routes>
        <Footer />
      </Router>
    </>
  );
}

export default App;
